import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutDetectionGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (typeof window === 'undefined') {
      return true;
    }

    if (this.hasActiveSession()) {
      return true;
    }

    this.authService.setLoggedInState(false, null);
    this.router.navigate(['/home']);
    return false;
  }

  private hasActiveSession(): boolean {
    if (this.authService.isLoggedIn) {
      return true;
    }

    try {
      const userData = localStorage.getItem('userData1');
      if (userData) {
        try {
          return !!JSON.parse(userData)?.id;
        } catch {
          return userData.length > 0;
        }
      }
    } catch {
      return false;
    }

    return !!(
      localStorage.getItem('eol_user_code') || localStorage.getItem('userCode')
    );
  }
}
